var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"pinIcon p-1",class:{ hoverable: _vm.hoverable },staticStyle:{"max-width":"none !important"},attrs:{"src":_vm.pinImageFiles[_vm.type],"height":_vm.height,"width":_vm.width},on:{"click":function($event){return _vm.$emit('pin-selected')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }